export default "__VITE_ASSET__7wpTPdjt__"